import { ArrowLeftIcon } from './ArrowLeftIcon';

/**
 * author: Google
 * id C21995A9-094F-4EA8-9127-BA0506B240A6
 * name arrow-left
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left.svg
 * tags
 * - Arrow 
 */
export const ArrowBackIcon = ArrowLeftIcon;
export default ArrowBackIcon